import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from "@material-ui/core/Button";
import { Container, Row, Col } from "shards-react";
import api from '../common/api';

class MaintenancePlansDueDates extends React.Component {

   constructor() {
      super();

      this.state = {
        isLoaded: false,
        maintenance_plans:[],
      }

    }

    async componentDidMount() {
      var params = this.getParams();
      await this.getMaintenancePlansDueDates(params.id);
    }
   
    getParams(){
      return this.props.match.params
    }

   getMaintenancePlansDueDates(id){
       const token =localStorage.getItem('userToken')
       return axios
                .get(api.maintenance_plans().expirations(id),{ headers: {"Authorization" : `Bearer ${token}`} })
                .then(res => {
                  this.setState({isLoaded: true, maintenance_plans: res.data})
                })
                .catch(err =>{
                  this.setState({isLoaded: true, maintenance_plans: [] })
                })
    }
    getMuiTheme = () =>
      createMuiTheme({
        overrides: {
          MuiTableCell: {
           root: {
             padding: '4px 12px 4px 12px',
             fontSize: '0.73rem'
            }
          }
        },
    });      

    handleDownload = () => {
      var formData = new FormData();
      const token = localStorage.getItem('userToken')
      axios.post(api.maintenance_plans(0).expirations_export(),
        formData,
        {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
            window.location.href = response.data
        })
        .catch(error => {
            alert('Falló la descarga')
      })

    }

    render(){
       const columns = [
       {
        name: "maintenance_plan_description",
        label: "Descripción",
        options: {
         filter: false,
         filterType: "textField",
         sort: true,
          }
        },
        {
        name: "plate",
        label: "Patente",
        options: {
         filter: false,
         filterType: "textField",
         sort: true,
          }
        },
        {
          name: "contract_name",
          label: "Contrato",
          options: {
           filter: true,
           display: false,
           filterType: "dropdown",
          }
        },
        {
          name: "task_name",
          label: "Tarea",
          options: {
           filter: true,
           filterType: "dropdown",
          }
        },
        {
          name: "last_km",
          label: "Últ. KM",
          options: {
           filter: false,
           filterType: "dropdown",
          }
        },
        {
          name: "service_last_km",
          label: "Ult Service KM",
          options: {
           filter: false,
           filterType: "dropdown",
          }
        },
        {
          name: "service_last_date",
          label: "Ult Service",
          options: {
           filter: false,
           filterType: "dropdown",
          }
        },
        {
          name: "up_to_km",
          label: "Proximo KM",
          options: {
           filter: false,
           filterType: "dropdown",
          }
        },
        {
          name: "reminaing_km",
          label: "KM restantes",
          optinos: {
            filter: false,
          }
        },
        {
          name: "remaning_months",
          label: "Meses restantes",
          optinos: {
            filter: false,
          }
        }
    ];

    const options = {
      onDownload: () => {
        this.handleDownload()
        return false
      },
      download: true,    
      print:false,
      responsive: 'stacked',
      selectableRows: false,
      rowsPerPage: 10,
      confirmFilters: false, 
      textLabels: {
            toolbar: {
              search: "Buscar",
              viewColumns: "Ver columnas",
              filterTable: "Filtros",   
              downloadCsv: "Exportar XLS",
            },
            body: {
                noMatch: this.state.isLoaded ?
                    'No hay resultados' :
                    <CircularProgress />,
            },
            selectedRows: {
              text: "fila(s) seleccionadas"
            },
            viewColumns: {
              title: "Ver columnas",
            },
            pagination: {
              next: "Siguiente",
              previous: "Anteior",
              rowsPerPage: "Cantidad por página:",
              displayRows: "de",      
            },
            filter: {
              all: "Todos",
              title: "Filtros",
              reset: "Limpiar"
            }
        }
    };

     return(
        <Container fluid className="main-content-container px-4">
            <Row>
              <Col className="p-2">
                <div>    
                  <MuiThemeProvider theme={this.getMuiTheme()}>
                    <MUIDataTable
                      title="Próximos Vencimientos"
                      data={Object.values(this.state.maintenance_plans)}
                      columns={columns}
                      options={options}
                    />
                    <div style={{textAlign: "right"}}>
                      <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
                        Volver
                      </Button>
                    </div>
                  </MuiThemeProvider>
                </div>
              </Col>
            </Row>
         </Container>
      );
    }

}

export default MaintenancePlansDueDates;   